import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalStateService } from 'src/app/services/modal-service/modal-state.service';

export interface ConditionalModalOptions {
  message?: string;
  iconName?: string;
  iconColor?: string;
  iconSize?: string;
  okButtonText?: string;
  okButtonColor?: string;
  noButtonText?: string;
  noButtonColor?: string;
}

@Component({
  selector: 'app-condition',
  templateUrl: './condition.component.html',
  styleUrls: ['./condition.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class ConditionComponent {

  @Input() message: string = 'MODAL.DEFAULTMESSAGE.CONDITIONAL';
  @Input() iconName: string = 'help-circle-outline';
  @Input() iconColor: string = 'warning';
  @Input() iconSize: string = '4.5em';
  @Input() okButtonText: string = 'BTN.OK';
  @Input() okButtonColor: string = 'success';
  @Input() noButtonText: string = 'BTN.NO';
  @Input() noButtonColor: string = 'danger';

  modalState: ModalStateService;

  constructor() {
    this.modalState = inject(ModalStateService);
  }

  close(result: boolean) {
    this.modalState.triggerDismiss("conditional", result);
  }
}